<form #form="ngForm">
    <rbac-label-grid
        name="rbacLabelGrid"
        [(ngModel)]="list"
    ></rbac-label-grid>
</form>
